// extracted by mini-css-extract-plugin
module.exports = {"BasePage__SkipMain":"BasePage_BasePage__SkipMain__ZyR_U","BasePage":"BasePage_BasePage__dMxNQ"};